<greco-simple-dialog [data]="dialogData">
  <form [formGroup]="form">
    <mat-form-field appearance="standard" style="width: 100%">
      <mat-label>Member Number</mat-label>
      <input matInput type="text" placeholder="123456789" formControlName="memberNumber" />
    </mat-form-field>
  </form>
</greco-simple-dialog>
